import React from 'react';
import { observer } from 'mobx-react-lite';
import { Div, Typography } from '@icecreamsocial/components';
import {
	BusinessProfileForm,
	Pagename,
	SteppedFormControls,
} from '../../../../presentational';
import { useStore } from '../../../../../utils/hooks';
import { useBusiness } from '../../../../providers/Business';

/**
 * @todo pass initial values as an object instead of spreading it
 */
const BusinessProfile = ({ handleSubmit, returnTo }) => {
	const { business } = useBusiness();
	const { data: userBusiness } = business;
	const initialValues = {
		businessName: userBusiness?.name,
		businessAddress: userBusiness?.businessAddress,
		supportEmail: userBusiness?.supportEmail,
		currency: userBusiness?.currency,
		language: userBusiness?.language,
		termsAndConditionsURL: userBusiness?.termsAndConditionsURL || '',
		privacyPolicyURL: userBusiness?.privacyPolicyURL || '',
		marketVertical: { value: userBusiness?.marketVertical?.id, label: userBusiness?.marketVertical?.segmentName },
		marketSubCategory: { value: userBusiness?.marketSubCategory?.id, label: userBusiness?.marketSubCategory?.segmentName },
	};

	return (
		<Div>
			<Pagename>Business Profile</Pagename>
			<Typography.P>Some basic questions about your business</Typography.P>
			<BusinessProfileForm
				onSubmit={handleSubmit}
				allowRouteBlock={false}
				renderControls={() => (
					<SteppedFormControls first={true} onNav={returnTo} />
				)}
				{...initialValues}
			/>
		</Div>
	);
};
BusinessProfile.displayName = 'BusinessSetUp.Profile';

export default observer(BusinessProfile);
